<template>
	<div>
		<div style="min-height: 300px;margin-left: 27px;display: flex;">
			<div @click="goToNoticeDetail(item)" class="trainList trainHover" v-for="(item,i) in trainData" :key="i" v-show="i<4">
				<div v-if="item.cover!='http://wdrm-admin.zkshare.com'">
					<img style="height: 11.25rem;width: 100%;" :src="item.cover">
				</div>
				<div v-if="item.cover=='http://wdrm-admin.zkshare.com'">
					<img style="height: 11.25rem;width: 100%;" src="../assets/images/instrument-default.jpg">
				</div>
				<p style="padding: 0 1rem;padding-top: 0.625rem;font-size: 14px;color: #1F1F1F;letter-spacing: 1px;">{{item.title}}</p>
				<div style="display: flex;flex-direction: column;font-size: 14px;color: #8E8E8E;letter-spacing: 1px;margin-top: 2.5rem;margin-left: 0.9375rem;">
					<div style="display: flex;">
						<div>培训时间：</div>
						<p style="margin: 0;">{{item.trainingDate}}</p>
					</div>
					
					<p style="margin: 0;">培训地点：{{item.location}}</p>
					<p style="margin: 0;">报名截止：{{item.regBeginDate}}</p>
				</div>
			</div>
		</div>
		<div style="display: flex;justify-content: center;margin-top: 4.1875rem;margin-bottom: 0.8rem;">
			<a-button type="primary" style="width: 6.625rem;height: 2.5rem;" @click="goToTrain">更多</a-button>
		</div>
		
	</div>
	
</template>

<script>
	export default{
		props:['trainData'],
		methods:{
			goToTrain(){
				this.$router.push({path:"/trainSign"})
			},
			goToNoticeDetail(data){
				this.$router.push({name:'noticeRichDetail',params:{data:data},query:{Ids:data.offlineTrainingId,state:2}})
				console.log(data)
			}
		}
	}
</script>

<style scoped>
	.trainList{
		width: 17.8125rem;
		cursor: pointer;
		height: 22rem;
		background: #FFFFFF;
		/* 悬浮 */
		box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.04);
		border-radius: 6px;
		overflow: hidden;
		margin-right: 30px;
		/* cursor: pointer; */
	}
	.trainHover:hover{
		box-shadow: 0 0.525rem 0.5625rem 0.3125rem rgba(221, 221, 221, 0.9);
		margin-top: -1px !important;
	}
	.trainHover{
		transition-duration: 0.45s;
	}
	
</style>
